module.exports = __webpack_public_path__ + "static/media/S5_Solve Puzzle.d9dcb6e7.svg";